import { render, staticRenderFns } from "./SSpinner.vue?vue&type=template&id=3c4d354e"
import script from "./SSpinner.vue?vue&type=script&lang=js"
export * from "./SSpinner.vue?vue&type=script&lang=js"
import style0 from "./SSpinner.vue?vue&type=style&index=0&id=3c4d354e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports